module.exports = __webpack_public_path__ + "img/SedangDiproses.890fa521.svg";